import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // A production integration can report the exception to its monitoring service.
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="not-found" id="main-content">
          <p className="not-found__eyebrow">Something went wrong</p>
          <h1 className="not-found__title">This page needs a moment.</h1>
          <p className="not-found__copy">
            Refresh the page or return to the collection to continue shopping.
          </p>
          <div className="not-found__actions">
            <a href="/shop">Shop all pieces</a>
            <a href="/">Return home</a>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
